import { makeRequest } from 'services/utils';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';

const { BulkEmailsOptOuts, BulkEmailsOptOutReasons } = Endpoints;
const { success: successCopies, errors: errorsCopies } = strings.bulkEmails;

export const getOptOutList = async params =>
  makeRequest({
    endpointOptions: {
      path: Endpoints.BulkEmailsOptOuts,
      queryParams: params
    },
    method: 'get',
    alertConfig: {
      error: {
        title: errorsCopies.optOutList.title
      }
    }
  });

export const loadReasons = async () =>
  makeRequest({
    url: BulkEmailsOptOutReasons,
    method: 'get',
    alertConfig: {
      error: {
        title: errorsCopies.optOutReasons.title
      }
    }
  });

/**
 *
 * @param {Object} formData
 * @param {number} formData.item_id
 * @param {number} formData.email_opt_out_type_id
 * @param {number} formData.unsubscribe_reason_id
 * @param {string} formData.custom_reason
 * @param {string} formData.notes
 * @returns {Promise}
 */
export const addToOptOut = async formData =>
  makeRequest({
    url: BulkEmailsOptOuts,
    data: formData,
    method: 'post',
    alertConfig: {
      success: {
        title: successCopies.addToOptOut.title,
        body: ({ email }) =>
          strings.formatString(successCopies.addToOptOut.body, {
            email
          })
      },
      error: {
        title: errorsCopies.createOptOut.title
      }
    }
  });

/**
 * Service removes selected item from opt out list adding item to opt in database
 * again. Contacts removed from opt out list will receive emails again
 *
 * @param {number} id
 * @param {boolean} isUnsubscribe
 * @returns {Promise}
 */
export const removeFromOptOut = async (id, data) =>
  makeRequest({
    endpointOptions: {
      path: Endpoints.BulkEmailsOptOutsRemoveById,
      replaceId: id,
      queryParams: { is_unsubscribe: data.is_unsubscribe }
    },
    method: 'delete',
    alertConfig: {
      success: {
        title: successCopies.removeFromOptOut.title,
        body: strings.formatString(successCopies.removeFromOptOut.body, {
          email: data.email
        })
      },
      error: {
        title: 'Error While Removing From Opt Out'
      }
    }
  });
